import React from 'react';

export default function Loader({ className: classNameProp, width, height }) {
  const style = {
    ...width && { width },
    ...height && { height },
  }
  return <div className={`loader ${classNameProp}`} style={style}/>
}
